module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ee-Ga.c8cfa76c.png";